var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45316_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51059 0.360187C10.9131 0.360187 12.2336 0.687851 13.4723 1.32254L13.6361 1.40444L13.4928 1.51705C13.1447 1.79344 12.8683 2.15174 12.6943 2.56122L12.6431 2.67382L12.5407 2.62264C11.5887 2.17221 10.5752 1.93676 9.52083 1.93676C5.62054 1.93676 2.45732 5.11022 2.45732 9.00027C2.45732 12.8903 5.6103 16.0638 9.51059 16.0638C13.4109 16.0638 16.5741 12.8903 16.5741 9.00027C16.5741 8.0687 16.4001 7.15761 16.0315 6.29771L15.9804 6.1851L16.093 6.13392C16.5127 5.98036 16.8812 5.72444 17.1781 5.39686L17.2907 5.25354L17.3623 5.41733C17.8844 6.55363 18.1404 7.7616 18.1404 8.97979C18.1404 13.74 14.2605 17.6198 9.50035 17.6198C4.74016 17.6198 0.860352 13.74 0.860352 8.97979C0.860352 4.21961 4.74016 0.339794 9.51059 0.360187ZM9.51059 5.06927C11.6706 5.06927 13.4416 6.83003 13.4518 9.01051C13.4518 11.191 11.6911 12.9517 9.51059 12.9517C7.33011 12.9517 5.56936 11.191 5.56936 9.01051C5.56936 6.83003 7.34035 5.06927 9.51059 5.06927ZM15.1512 1.81392C16.1462 1.81392 16.9529 2.62057 16.9529 3.61562C16.9529 4.61068 16.1462 5.41733 15.1512 5.41733C14.1561 5.41733 13.3495 4.61068 13.3495 3.61562C13.3495 2.62057 14.1561 1.81392 15.1512 1.81392Z",
    fill: "#3880FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45316_1198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.28,
    height: 17.28,
    fill: "white",
    transform: "translate(0.860352 0.360107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.3e3e3b5ccc4832e8cb3d938919773873.svg";
export { ForwardRef as ReactComponent };